import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import CommonGrid from "../CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { fetchLoanAging } from "../../store/reducers/dashboardSlice/api";
import { gridColumns_LoanAgeing } from "../../Utils/TableColumnDefs";
import { reduceSum } from "../../Utils";
import { useAbortController } from "../../hooks/useAbortController";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = () => {
  const { signal } = useAbortController();
  const dispatch = useDispatch();
  const lenderId = useSelector((state) => state.account.lenderId);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const valuesToPopulate = useSelector(
    (state) => state.dashboard.doughnut.valuesToPopulate
  );
  const loanAgingTable = useSelector(
    (state) => state.dashboard.doughnut.loanAgingTable
  );
  const loanAgingStatus = useSelector(
    (state) => state.dashboard.doughnut.status
  );
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (loanAgingStatus === "idle") {
      dispatch(fetchLoanAging({ lenderId, role: selectedRole, signal }));
    }
  }, [dispatch, loanAgingStatus, lenderId, selectedRole]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const LabelsData = valuesToPopulate?.map((data) => data.category);
  const chartValues = valuesToPopulate?.map((data) => data.value);

  const totalValue = reduceSum(valuesToPopulate?.map((data) => data.value));
  const data = {
    labels: LabelsData,
    datasets: [
      {
        data: chartValues,
        backgroundColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(255, 99, 13, 1)",
          "rgba(54, 162, 23, 1)",
          "rgba(255, 206, 8, 1)",
          "rgba(75, 192, 19, 1)",
          "rgba(153, 102, 25, 1)",
          "rgba(255, 159, 6, 1)",
        ],
        borderWidth: 0,
        cutout: "80%",
        // radius: "80%",
        hoverOffset: 5,
      },
    ],
  };
  const textCenter = {
    id: "textCenter",
    beforeDatasetDraw: function (chart, a, b) {
      var width = chart.width,
        height = chart.height - 12,
        ctx = chart.ctx;

      ctx.restore();
      var fontSize = (height / 114).toFixed(2);
      ctx.font = fontSize - 1 + "rem sans-serif";
      ctx.textBaseline = "middle";

      var text = "Total",
        textX = Math.round((width - ctx.measureText(text).width) / 2) - 40,
        textY = height / 2;

      var text2 = totalValue,
        textX2 = Math.round((width - ctx.measureText(text2).width) / 2) - 40,
        textY2 = height / 2;

      ctx.fillText(text, textX, textY);
      ctx.fillText(text2, textX2, textY2 + 30);
      ctx.save();
    },
  };
  return (
    <>
      <div className="col-lg-12">
        <div
          className="bg-white w-100 d-flex flex-column justify-content-center align-items-center mt-3"
          style={{ height: "96%", position: "relative" }}
        >
          <ChartDetailsModal
            handleClose={handleClose}
            loanAgingTable={loanAgingTable}
            show={show}
            Chart={
              <div className="col-sm-12 bg-white d-flex flex-column justify-content-center align-items-center">
                <h5>Loan Aging</h5>
                <div
                  className="chart-container"
                  style={{ height: "300px", position: "relative" }}
                >
                  <Doughnut
                    options={options}
                    data={data}
                    plugins={[textCenter]}
                  />
                </div>
              </div>
            }
          />

          <div
            className="chart-container"
            onClick={handleShow}
            style={{ height: "300px", position: "relative" }}
          >
            {loanAgingStatus === "fulfilled" ? (
              totalValue < 1 ? (
                <p>NO DATA AVAILABLE</p>
              ) : (
                <Doughnut
                  options={options}
                  data={data}
                  plugins={[textCenter]}
                />
              )
            ) : loanAgingStatus === ("loading" || "idle") ? (
              <SpinnerBlock height={"10vh"} />
            ) : (
              "Failed"
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DoughnutChart;
const options = {
  // responsive: true,

  plugins: {
    legend: {
      position: "right",
      labels: {
        usePointStyle: true,
        padding: 12,
        font: {
          size: 11,
        },
      },
    },
    title: {
      display: false,
    },
  },
};

const ChartDetailsModal = ({ handleClose, loanAgingTable, show, Chart }) => {
  return (
    <div className="loan-aging-popup">
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        dialogClassName="mw-100 p-5"
      >
        <Modal.Header closeButton>
          <Modal.Title>Chart Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          {Chart}
          {loanAgingTable && (
            <CommonGrid
              gridColumns={gridColumns_LoanAgeing}
              columnData={loanAgingTable}
              viewAllModal={false}
              tHeight={"65vh"}
              tableTotal={[
                "principalBalance",
                "current",
                "zeroToThirty",
                "tillSixty",
                "tillNinety",
                "NinetyOnePlus",
              ]}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* {summary.principalBalance} */}
          {/* {summary.principalBalance} */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
